import c from "class-c";

import styles from "./Tag.module.scss";

declare namespace Tag {
  type Props = {
    class?: string;
    name: string;
    color?: string;
  };
}

function Tag({ class: className, name, color, ...props }: D<Tag.Props>) {
  return (
    <div
      class={c`${styles["tag"]} text:small+ ${className}`}
      style={{ background: color || "var(--background-accent)" }}
      {...props}
    >
      {name}
    </div>
  );
}

export default Tag;
